// Environment configuration interface
interface EnvironmentConfig {
    IdentityBaseUrl: string;
    ClientId: string;
    EnvironmentLabel: string;
    SignalRUrl: string;
    WebApiUrl: string;
    CompanionUrl: string;
}

// Web hostname matchers - order matters (first match wins)
const HOST_MATCHERS: Array<{ match: (host: string, port: string) => boolean; env: string }> = [
    { match: (h) => h.startsWith("manage-qat."), env: "QAT" },
    { match: (h) => h.startsWith("manage-uat."), env: "UAT" },
    { match: (h) => h.startsWith("manage-stg."), env: "STG" },
    { match: (h) => h.startsWith("manage."), env: "PROD" },
    { match: (h, p) => h === "localhost" && p === "44342", env: "DEV" },
];

// Environment configuration table
const ENVIRONMENT_CONFIG: Record<string, EnvironmentConfig> = {
    DEV: {
        IdentityBaseUrl: "https://localhost:5001",
        ClientId: "auggie-spa-management-dev",
        EnvironmentLabel: "Development Environment",
        SignalRUrl: "http://localhost:7172/api",
        WebApiUrl: "https://localhost:44358/",
        CompanionUrl: "https://localhost:44343/",
    },
    QAT: {
        IdentityBaseUrl: "https://auth-qat.airprodiag.com",
        ClientId: "auggie-spa-management-qat",
        EnvironmentLabel: "Quality Assurance Testing Environment",
        SignalRUrl: "https://api-qat.auggie.tech/signalr",
        WebApiUrl: "https://api-qat.auggie.tech/manage/",
        CompanionUrl: "https://companion-qat.auggie.tech/",
    },
    UAT: {
        IdentityBaseUrl: "https://auth-uat.airprodiag.com",
        ClientId: "auggie-spa-management-uat",
        EnvironmentLabel: "User Acceptance Testing Environment",
        SignalRUrl: "https://api-uat.auggie.tech/signalr",
        WebApiUrl: "https://api-uat.auggie.tech/manage/",
        CompanionUrl: "https://companion-uat.auggie.tech/",
    },
    STG: {
        IdentityBaseUrl: "https://auth-stg.airprodiag.com",
        ClientId: "auggie-spa-management-stg",
        EnvironmentLabel: "",
        SignalRUrl: "https://api-stg.auggie.tech/signalr",
        WebApiUrl: "https://api-stg.auggie.tech/manage/",
        CompanionUrl: "https://companion-stg.auggie.tech/",
    },
    PROD: {
        IdentityBaseUrl: "https://auth.airprodiag.com",
        ClientId: "auggie-spa-management-prd",
        EnvironmentLabel: "",
        SignalRUrl: "https://api.auggie.tech/signalr",
        WebApiUrl: "https://api.auggie.tech/manage/",
        CompanionUrl: "https://companion.auggie.tech/",
    },
};

export class Globals {

    private static cachedEnvKey: string | null = null;

    private static getEnvKey(): string {
        if (this.cachedEnvKey) return this.cachedEnvKey;

        const host = globalThis.location.hostname;
        const port = globalThis.location.port;
        for (const { match, env } of HOST_MATCHERS) {
            if (match(host, port)) {
                this.cachedEnvKey = env;
                return env;
            }
        }
        throw new Error(`Unknown host: ${host}`);
    }

    private static getConfig(): EnvironmentConfig {
        return ENVIRONMENT_CONFIG[this.getEnvKey()];
    }

    public static GetEnvironment(): string {
        return this.getConfig().EnvironmentLabel;
    }

    public static GetSignalRFunction(): string {
        return this.getConfig().SignalRUrl;
    }

    public static GetWebApi(): string {
        return this.getConfig().WebApiUrl;
    }

    public static GetCompanionUrl(): string {
        return this.getConfig().CompanionUrl;
    }

    public static IdentityUrl(url: string): string {
        return this.getConfig().IdentityBaseUrl + url;
    }

    public static GetIdentityClientId(): string {
        return this.getConfig().ClientId;
    }
}
export default Globals;
